import React from 'react';
import { SimpleCard } from '@redturtle/volto-io-studio/components';

/* Style */
import './CardsAppearance.less';

const CardsAppearance = ({ item, isEditMode }) => {
  return (
    <div className="cards-appearance">
      <SimpleCard item={item} isEditMode={isEditMode} showButton={false} />
    </div>
  );
};
export default CardsAppearance;
